// extracted by mini-css-extract-plugin
export default {"root":"whitecard_root__M3iCd","container":"whitecard_container__5jO4b","divider":"whitecard_divider__iC45X"};